import { useIsCategoryPageLoading } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoading";
import { useLayoutElementsLoading } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useLayoutElementsLoading";
import { useIsHubCategoryLoadingStrategy } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsHubCategoryLoadingStrategy";

export const useIsProductOrBrandGridLoading = () => {
  const isCatnavResultsLoading = useIsCategoryPageLoading();
  const isLayoutElementsLoading = useLayoutElementsLoading();
  const shouldBlockOnLayoutElements = useIsHubCategoryLoadingStrategy();

  return shouldBlockOnLayoutElements
    ? isLayoutElementsLoading || isCatnavResultsLoading
    : isCatnavResultsLoading;
};
